@use 'src/globals/main';

pn-toast {
  position: relative;
  display: block;
  overflow: hidden;
}

pn-toast .pn-toast {
  position: relative;

  color: main.$gray900;
  padding: 1em;
  border-radius: 0.5em;

  outline: none;
  font-size: 1em;
  font-weight: 400;
  background-color: main.$blue50;
  border-color: main.$blue700;

  display: flex;
  align-items: center;
  gap: 0.75em;

  visibility: visible;

  @include main.pn-transition('visibility');

  @include main.pn-ripple(main.$blue700);

  &[data-hide] {
    visibility: hidden;
    transition-delay: main.$timing;
  }

  &-heading {
    font-size: 1em;
    font-style: normal;
    font-weight: 500;
    margin: 0;
  }

  &-text {
    font-size: 1em;
    font-style: normal;
    font-weight: 400;
    margin: 0 0 0.25em 0;
    &:last-child {
      margin-bottom: 0;
    }
  }

  &-icon .pn-icon-svg path {
    fill: main.$gray900;
    @include main.pn-transition('fill');
  }

  &-content {
    display: flex;
    flex-direction: column;
    align-self: center;
    align-items: flex-start;
    gap: 0.25em;
    margin: 0 auto 0 0;
  }

  &-button {
    cursor: pointer;
    border-radius: 50%;
    border: none;
    background: none;
    padding: 0.25em;
    font-size: 1em;
    display: flex;
    align-items: center;
    justify-content: center;
    @include main.pn-transition('background-color, outline-color');

    @include main.pn-focus(main.$blue700, main.$blue200);

    &:hover {
      background-color: main.$blue200;
    }
  }

  &[data-appearance='success'] {
    background-color: main.$green50;

    .pn-toast-button {
      @include main.pn-focus(main.$green700, main.$green200);

      &:hover {
        background-color: main.$green200;
      }
    }

    .pn-ripple {
      background-color: main.$green700;
    }

    .pn-toast-icon .pn-icon-svg path {
      fill: main.$green700;
    }

    &[data-temporary] {
      border-color: main.$green700;
    }
  }

  &[data-appearance='warning'] {
    background-color: main.$orange50;

    .pn-toast-button {
      @include main.pn-focus(main.$orange700, main.$orange200);

      &:hover {
        background-color: main.$orange200;
      }
    }

    .pn-ripple {
      background-color: main.$orange700;
    }

    .pn-toast-icon .pn-icon-svg path {
      fill: main.$orange700;
    }

    &[data-temporary] {
      border-color: main.$orange500;
    }
  }

  &[data-appearance='error'] {
    background-color: main.$coral50;

    .pn-toast-button {
      @include main.pn-focus(main.$warning, main.$coral200);

      &:hover {
        background-color: main.$coral200;
      }
    }

    .pn-ripple {
      background-color: main.$warning;
    }

    .pn-toast-icon .pn-icon-svg path {
      fill: main.$warning;
    }

    &[data-temporary] {
      border-color: main.$warning;
    }
  }

  &[data-temporary] {
    border-style: solid;
    border-width: 0.0625em;
    box-shadow: 0 0.125em 0.25em rgba(0, 0, 0, 0.2);
  }
}
